/**
 * @file JS - Controller - DataPageController.js
 * @author : Adam Lemire
 * @since 2021/06/14
 * @version 1.0
 * @summary Dernières modifications : 2023/01/25
 * https://datatables.net/examples/api/select_row.html
 * https://datatables.net/manual/data/
 */

import DataPage from '../../classes/Page/DataPage.js';
import VectorLayer from '../../classes/Layer/VectorLayer.js'; // eslint-disable-line no-unused-vars
import { GisSection } from '../../helpers/Selectors.js';
import { waitForElement } from '../../helpers/GlobalFunctions.js';
import { Evenements } from '../../events/Evenements.js';
import 'datatables.net';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-buttons';
import 'datatables.net-select';
import 'datatables.net-rowreorder';
import 'datatables.net-scroller';

export default class DataPageController {
  constructor () {
    /** @type { DataPage } */
    this._pageTableau = null;
    /** @type { DataPage [] } */
    this._pagesTableau = new Map();
    /** @type { DataTable.Api } */
    this._dataTable = undefined;
    this._selectionDepuisExterne = false;
  }

  get dataPage () { return this._pageTableau; }

  set dataPage (dataPage) { this._pageTableau = dataPage; }

  get dataPages () { return this._pagesTableau; }

  set dataPages (dataPages) { this._pagesTableau = dataPages; }

  get dataTable () { return this._dataTable; }

  get selectionDepuisExterne () { return this._selectionDepuisExterne; }

  set selectionDepuisExterne (valeurBool) { this._selectionDepuisExterne = valeurBool; }

  /*
   * Création et affichage
   */

  activer () {
    this._ecouterRedimensionnementFenetre();
  }

  /**
   * @param { VectorLayer } vectorLayer
   * @param { number } mapPageId
   * @returns { DataPage }
   */
  async creerNouvelleDataPage (vectorLayer, mapPageId) {
    const _this = this;
    console.log('creerNouvelleDataPage');
    const dataPage = new DataPage(vectorLayer, mapPageId);
    const dataPagePrête = await dataPage;
    dataPage.registerListeners();

    if (this._pageTableau) {
      this._minimiserFenetre();
    }

    this._pageTableau = dataPagePrête;
    this._pagesTableau.set(dataPage.id, dataPagePrête);
    this._creerConteneurHtml(dataPagePrête);
    const dataTable = await this._creerDataTable(dataPagePrête);

    /**
     * @param { DataPage } pdataPagePrête
     * @param { DataTable } pdataTable
     * @returns { DataPage }
     */
    function exécuterFonctionsSync (pdataPagePrête, pdataTable) {
      console.log('exécuterFonctionsSync');
      _this._créerOngletDansVue(pdataPagePrête);
      _this._instancierAuditeurs();
      return pdataPagePrête;
    }

    // ici retourne probablement avant que tout soit pret

    return exécuterFonctionsSync(dataPagePrête, dataTable);
  }

  afficherDataPage () {
    console.log('afficherDataPage');
    const autresDataPages = '.datapage-' + this._pageTableau.mapPageId;
    const conteneurId = this._pageTableau.conteneurId;
    const idDataSection = '#data__section-' + this._pageTableau.mapPageId;
    const ongletDataPageId = '#data-tab-' + this._pageTableau.mapPageId + '-' + this._pageTableau.id;

    $(autresDataPages).hide();
    $(GisSection.DATA).show();
    $(idDataSection).show();
    $(conteneurId).show();
    try { this._dataTable.draw(); } catch (e) { console.log(e); }
    $(ongletDataPageId).addClass('active');
    this._defilerASelection();
  }

  // ! en cours
  /**
   * @param { DataPage } pageTableau
   */
  supprimer (pageTableau) {
    const idConteneur = pageTableau.conteneurId;
    const idDataPage = pageTableau.id;
    const idDataTab = '#data-tab-' + pageTableau.mapPageId + '-' + idDataPage;

    $(idConteneur).remove();
    $(idDataTab).remove();
    Evenements.dataPageSupprimee.notify(pageTableau);
    if (this._pageTableau === pageTableau) {
      this._pageTableau = undefined;
    }
    this._pagesTableau.delete(idDataPage);
    $(GisSection.DATA).hide();
    this._notifierSupprimer(idDataPage);
  }

  _instancierAuditeurs () {
    this._ecouterBoutonsGererFenetre();
    this._écouterOnglet();
    this._ecouterChangementNomLayer();
    this._écouterSélectionDepuisDataTable();
  }

  _ecouterChangementNomLayer () {
    const _this = this;
    const dataPage = this._pageTableau;

    this._pageTableau.registerLayerNameChangedListener(function () {
      _this._pageTableau = dataPage;
      _this._modifierTitreConteneurHtml();
      _this._modifierTexteOnglet();
    });
  }

  /*
   * CONTENEUR HTML
   */

  _modifierTitreConteneurHtml () {
    const titreDataPage = '#datapage-' + this._pageTableau.mapPageId + '-' + this._pageTableau.id + ' .datapage__titre';

    $(titreDataPage).html(this._pageTableau.title);
  }

  _creerConteneurHtml () {
    const htmlContainer = '<div id="datapage-' + this._pageTableau.mapPageId + '-' + this._pageTableau.id + '" class="datapage datapage-' + this._pageTableau.mapPageId + '">' +
      '<div class="datapage__header">' +
      '<div class="datapage__titre">' + this._pageTableau.title + '</div>' +
      '<button id="datapage__minimise-button-' + this._pageTableau.mapPageId + '-' + this._pageTableau.id + '" class="datapage__minimise-button"> _ </button>' +
      '<button id="datapage__close-button-' + this._pageTableau.mapPageId + '-' + this._pageTableau.id + '" class="datapage__close-button"> X </button>' +
      '</div>' +
      '<table id="datatable-' + this._pageTableau.mapPageId + '-' + this._pageTableau.id + '" class="datatable datatable-' + this._pageTableau.mapPageId + ' hover order-column cell-border">' +
      '</table>' +
      '</div>';
    const parentId = '#data__section-' + this._pageTableau.mapPageId;

    $(parentId).append(htmlContainer);
  }

  // ! url langue à mettre en constante, et classes .data à changer
  /**
   * @param { DataPage } dataPage
   * @returns { DataTable }
   */
  async _creerDataTable (dataPage) {
    console.log('_creerDataTable');
    const _this = this;
    const data = dataPage.features;
    const conteneurId = '#datatable-' + dataPage.mapPageId + '-' + dataPage.id;
    const hauteurBarreRecherche = parseInt($('body').css('font-size')) * 1.5 + 8;
    const hauteurBarreTableHead = parseInt($('body').css('font-size')) * 1.5 + 20;
    const hauteurBasTable = 73;
    const hauteurTBody = $('.data').height() - $('.datapage__header').height() - hauteurBarreRecherche - hauteurBarreTableHead - hauteurBasTable;
    // const largeurDataTable = $('.data__section').width();

    const colonnes = [];
    Object.keys(data[0]).forEach(function (nomColonne) {
      colonnes.push({ title: nomColonne, data: nomColonne });
    });

    const conteneurIdPromise = waitForElement(conteneurId);
    console.log('id en attente: %o, résutlat: %o', conteneurId, conteneurIdPromise);

    /**
     * @param { * } pconteneurIdPromise
     * @returns { DataTable }
     */
    function _mCréerDataTable (pconteneurIdPromise) {
      $(pconteneurIdPromise).DataTable({
        autoWidth: false,
        data: data,
        columns: colonnes,
        select: true,
        language: window.localStorage.getItem('lang') === 'en' ? $.fn.dataTable.defaults : { url: '/_data/dataTables.fr.json' },
        scroller: {
          loadingIndicator: false
        },
        scrollY: hauteurTBody,
        scrollX: true,
        scrollCollapse: true,
        rowId: function (a) {
          return 'row_' + a[_this._pageTableau.nomColonneId];
        },
        drawCallback: function (settings) {
          $('.dataTables_length').hide();
          $('.dataTables_paginate').hide();
          $('.dts_label').hide();
        },
        deferRender: true
      }); // dictionary.dataTable.en

      _this._dataTable = $(pconteneurIdPromise).DataTable();
      return $(pconteneurIdPromise).DataTable();
    }

    const dataTable = _mCréerDataTable(await conteneurIdPromise);
    return dataTable;
  }

  recreerDataTable (dataPage) {
    const conteneurId = '#datatable-' + dataPage.mapPageId + '-' + dataPage.id;

    $(conteneurId).DataTable().destroy();
    $(conteneurId).empty();
    this._creerDataTable(dataPage);
  }

  recreerDataTableActive () {
    if (this._pageTableau) {
      console.log('recreerDataTableActive(), DataPage active du controleur: %o', this._pageTableau);
      const dataPage = this._pageTableau;
      const conteneurId = '#datatable-' + dataPage.mapPageId + '-' + dataPage.id;

      $(conteneurId).DataTable().destroy();
      $(conteneurId).empty();
      this._creerDataTable(dataPage);
    }
  }

  _ecouterRedimensionnementFenetre () {
    const _this = this;
    Evenements.redimensionnementFenetre.subscribe(function () {
      _this.recreerDataTableActive();
    });
  }

  /*
   * ONGLETS
   */

  /** @param { DataPage } dataPage */
  _créerOngletDansVue (dataPage) {
    console.log('_créerOngletDansVue, datapage = %o', dataPage);
    const idRow = '#data-tabs-' + dataPage.mapPageId;

    if (!$(idRow).length) {
      const dataPageTabs = '<div id="data-tabs-' + dataPage.mapPageId + '" class="data-tabs__row">' +
      '<div id="data-tab-' + dataPage.mapPageId + '-' + dataPage.id + '" class="data-tab" data-mappage-id="' + dataPage.mapPageId + '" data-datapage-id="' + dataPage.id + '">' + dataPage.title + '</div>' +
      '</div>';

      $(GisSection.DATA_TABS).append(dataPageTabs);
    } else {
      const dataPageTab = '<div id="data-tab-' + dataPage.mapPageId + '-' + dataPage.id + '" class="data-tab" data-mappage-id="' + dataPage.mapPageId + '" data-datapage-id="' + dataPage.id + '">' + dataPage.title + '</div>';

      $(idRow).append(dataPageTab);
    }
  }

  _écouterOnglet () {
    const _this = this;
    const idDataTab = '#data-tab-' + this._pageTableau.mapPageId + '-' + this._pageTableau.id;

    $(idDataTab).on('click tap', function () {
      if ($(this).hasClass('active')) {
        _this._minimiserFenetre();
      } else {
        _this._pageTableau = _this._pagesTableau.get(parseInt($(this).data('datapage-id')));
        const idDataSection = '#data__section-' + _this._pageTableau.mapPageId;
        const conteneurId = _this._pageTableau.conteneurId;
        const autresDataPages = '.datapage-' + _this._pageTableau.mapPageId;
        const dataTableId = '#datatable-' + _this._pageTableau.mapPageId + '-' + _this._pageTableau.id;
        const indexSelectionElement1 = $(dataTableId).DataTable().rows({ selected: true }).indexes()[0];

        $(autresDataPages).hide();
        $(GisSection.DATA).show();
        $(idDataSection).show();
        $(conteneurId).show();
        $(dataTableId).DataTable().draw();
        $('.data-tab').removeClass('active');
        $(this).addClass('active');
        if (indexSelectionElement1) $(dataTableId).DataTable().row(indexSelectionElement1).scrollTo(false);
      }
    });
  }

  _modifierTexteOnglet () {
    const idDataPageTab = '#data-tab-' + this._pageTableau.mapPageId + '-' + this._pageTableau.id;

    $(idDataPageTab).html(this._pageTableau.title);
  }

  /*
   * BOUTONS FENÊTRE DATATABLE
   */

  _ecouterBoutonsGererFenetre () {
    const _this = this;
    const pageTableau = this._pageTableau;
    const idBoutonMinimiser = '#datapage__minimise-button-' + pageTableau.mapPageId + '-' + pageTableau.id;
    const idBoutonFermer = '#datapage__close-button-' + pageTableau.mapPageId + '-' + pageTableau.id;

    $(idBoutonMinimiser).on('click tap', function () {
      _this._minimiserFenetre();
    });

    $(idBoutonFermer).on('click tap', function () {
      _this.supprimer(pageTableau);
    });
  }

  _minimiserFenetre () {
    const idDataTab = '#data-tab-' + this._pageTableau.mapPageId + '-' + this._pageTableau.id;
    const idConteneur = this._pageTableau.conteneurId;

    $(idConteneur).hide();
    $(GisSection.DATA).hide();
    $(idDataTab).removeClass('active');
  }

  _fermerFenetre () {
    const idDataTab = '#data-tab-' + this._pageTableau.mapPageId + '-' + this._pageTableau.id;
    const idConteneur = this._pageTableau.conteneurId;
    const idDataPage = this._pageTableau.id;

    $(idConteneur).remove();
    $(idDataTab).remove();
    Evenements.dataPageSupprimee.notify(this._pageTableau);
    this._pageTableau = undefined;
    this._pagesTableau.delete(idDataPage);
    $(GisSection.DATA).hide();
    this._notifierSupprimer(idDataPage);
  }

  _notifierSupprimer (pageId) { }

  écouterSupprimer (auditeur) {
    this._notifierSupprimer = auditeur;
  }

  /*
   * SÉLECTION
   */

  async _écouterSélectionDepuisDataTable () {
    const _this = this;
    const dataTable = await this._dataTable;
    const dataPage = await this._pageTableau;

    try {
      dataTable.on('select.dt deselect.dt', function (e, dt, type, indexes) {
        if (type === 'row') {
          const idSelectionnes = [];

          _this._dataTable.rows({ selected: true }).every(function (rowIdx, tableLoop, rowLoop) {
            idSelectionnes.push(this.data()[dataPage.nomColonneId]);
            return true;
          });

          if (!_this.selectionDepuisExterne) {
            _this._notifierSélectionChangée({ vectorLayer: dataPage._vectorLayer, idSelectionnes: idSelectionnes });
          }
        }
      });
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * @param { object } objetSelection
   * @param { VectorLayer } objetSelection.vectorLayer
   * @param { number [] } objetSelection.idSelectionnes
   */
  _notifierSélectionChangée (objetSelection) {}

  écouterSélectionChangée (auditeur) {
    this._notifierSélectionChangée = auditeur;
  }

  /**
   * @description modifier la sélection dans la table active préexistante
   * @param { string [] } idSelectionnes
   * @returns { boolean }
   */
  async modifierSelection (idSelectionnes) {
    if (this._dataTable) {
      const mIdSelectionnes = [];
      this.selectionDepuisExterne = true;
      this._dataTable.rows({ selected: true }).deselect();

      idSelectionnes.forEach(function (idSelect) {
        const idRow = '#row_' + idSelect;
        const dataTableRowPromise = new Promise((resolve, reject) => {
          waitForElement(idRow);
        });

        dataTableRowPromise.then(mIdSelectionnes.push(idRow));
      });

      this._dataTable.rows(await mIdSelectionnes).select();
      this.selectionDepuisExterne = false;
      return true;
    }
  }

  /**
   * @description modifier la sélection dans la table active lorsque la sélection existant avant la création de la table
   * @param { string [] } idSelectionnes
   */
  async modifierSelectionApresCreation (idSelectionnes) {
    const _this = this;
    const dataTable = await this._dataTable;
    dataTable.on('init.dt', async function () {
      const pret = await _this.modifierSelection(idSelectionnes);
      _this._defilerASelection(pret);
    });
  }

  _defilerASelection () {
    const indexSelectionElement1 = this._dataTable.rows({ selected: true }).indexes()[0];
    if (indexSelectionElement1) this._dataTable.row(indexSelectionElement1).scrollTo(false);
  }
}
